<div class="row mb-4">
    <div class="col-12 mb-4">
        <div class="card card-custom">
            <div class="card-header border-0 bg-primary">
                <div class="card-title">
				    <span class="card-icon">
					    <i class="flaticon-imac text-white"></i>
                    </span>
                    <h3 class="card-label text-white">Instances</h3>
                </div>
                <div class="card-toolbar text-white">
                    <button mat-icon-button (click)="getInstances()">
                        <mat-icon aria-label="Refresh">autorenew</mat-icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingInstances$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingInstances$ | async) &&!(hasInstances$ | async)">No instances found!</div>
                <div *ngIf="!(loadingInstances$ | async) && (hasInstances$ | async)" class="table-responsive">
                    <table class="table text-center">
                        <thead>
                        <tr>
                            <th scope="col">Label</th>
                            <th scope="col">Region</th>
                            <th scope="col">IP</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let instance of instances$ | async">
                            <ng-container [ngTemplateOutlet]="InstanceTemplate" [ngTemplateOutletContext]="{item: instance}"></ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mb-4">
    <div class="col-12 mb-4">
        <div class="card card-custom">
            <div class="card-header border-0 bg-primary">
                <div class="card-title">
				    <span class="card-icon">
					    <i class="flaticon2-box-1 text-white"></i>
                    </span>
                    <h3 class="card-label text-white">Snapshots</h3>
                </div>
                <div class="card-toolbar text-white">
                    <button mat-icon-button (click)="getSnapshots()">
                        <mat-icon aria-label="Refresh">autorenew</mat-icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingSnapshots$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingSnapshots$ | async) &&!(hasSnapshots$ | async)">No snapshots found!</div>
                <div *ngIf="!(loadingSnapshots$ | async) && (hasSnapshots$ | async)" class="table-responsive">
                    <table class="table text-center">
                        <thead>
                        <tr>
                            <th scope="col">Description</th>
                            <th scope="col">Created</th>
                            <th scope="col">Status</th>
                            <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let snapshot of snapshots$ | async">
                            <ng-container [ngTemplateOutlet]="SnapshotTemplate" [ngTemplateOutletContext]="{item: snapshot}"></ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #InstanceTemplate let-item="item">
    <tr>
        <td nowrap>{{item.label}}</td>
        <td nowrap>{{item.region}}</td>
        <td nowrap>{{item.mainIp}}</td>
        <td nowrap>{{item.status}}</td>
        <td nowrap>
            <button mat-icon-button>
                <mat-icon aria-label="KVM">
                    <a target="_blank" href="{{item.kvm}}">desktop_windows</a>
                </mat-icon>
            </button>
            <button mat-icon-button color="accent" (click)="createSnapshot(item)">
                <mat-icon aria-label="Snapshot">camera_alt</mat-icon>
            </button>
        </td>
    </tr>
</ng-template>

<ng-template #SnapshotTemplate let-item="item">
    <tr>
        <td nowrap>{{item.description}}</td>
        <td nowrap>{{item.dateCreated}}</td>
        <td nowrap>{{item.status}}</td>
        <td nowrap>
            <button mat-icon-button color="warn">
                <mat-icon aria-label="Delete">delete</mat-icon>
            </button>
        </td>
    </tr>
</ng-template>